import { SignIn } from "@clerk/tanstack-react-start";
import { createFileRoute } from "@tanstack/react-router";
import { loginHead, validateLoginSearch } from "~/lib/login-search.ts";

/**
 * FlirtMachine admin login page
 *
 * The brand's admin door — reachable at `flirtmachine.app/admin/login`. This is
 * where the "Admin Portal" copy belongs: it encodes the *intent* to do admin
 * work, so after sign-in it lands the user on `/flirtmachine/admin`. The file
 * lives OUTSIDE the `_authenticated` layout so it stays a public path (an
 * unauthenticated admin must be able to reach the form). Authorization for the
 * admin console itself is enforced by the `/admin` route guard, not by this
 * redirect.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/flirtmachine/admin/login/")({
  validateSearch: validateLoginSearch,
  head: () => loginHead("FlirtMachine"),
  component: FlirtMachineAdminLogin,
});

export function FlirtMachineAdminLogin() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6">
      <div className="text-center">
        <h1 className="text-2xl font-bold tracking-widest uppercase text-zinc-100">
          FlirtMachine
        </h1>
        <p className="mt-2 text-sm uppercase tracking-widest text-zinc-500">
          Admin Portal
        </p>
      </div>
      <SignIn
        routing="path"
        path="/admin/login"
        fallbackRedirectUrl="/flirtmachine/admin"
      />
    </div>
  );
}
